import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from './account.service';
import { Observable ,  of } from 'rxjs';



@Injectable()
export class AccountResolverService  implements Resolve<any> {
  id: any;
  constructor( private accountService: AccountService) {

  }

  resolve(route: ActivatedRouteSnapshot, routerstate: RouterStateSnapshot): Observable<any> {
    return this.accountService.getAccountDetailsById(route.params['id']);

    }
}
